import { Pipe, PipeTransform } from '@angular/core';
import { zipObject, hexToRgba } from '../utils/helpers';
import { COLOR_NAMES } from '../constants';

const _colorMap = zipObject(
    COLOR_NAMES.map(function(record) {
        return [record.color, 'color-label-' + record.name];
    })
);
const _ncolorMap = zipObject(
    COLOR_NAMES.map(function(record) {
        return [record.color, record.n_color];
    })
);

function mixColor(color1, color2, alpha) {
    if (!color1 || !color2) {
        return;
    }
    const r1 = color1[0];
    const g1 = color1[1];
    const b1 = color1[2];
    const ALPHA = 1 - alpha;

    const r2 = color2[0];
    const g2 = color2[1];
    const b2 = color2[2];

    const r = +((1 - ALPHA) * r1 + ALPHA * r2);
    const g = +((1 - ALPHA) * g1 + ALPHA * g2);
    const b = +((1 - ALPHA) * b1 + ALPHA * b2);

    return 'RGB(' + r + ',' + g + ',' + b + ')';
}

function getRGB(color, returnArray) {
    if (!color) {
        return;
    }

    const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    let sColor = color.toLowerCase();
    if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
            let sColorNew = '#';
            for (let i = 1; i < 4; i += 1) {
                sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
            }
            sColor = sColorNew;
        }
        // å¤çå­ä½çé¢è²å¼
        const sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
            sColorChange.push(+('0x' + sColor.slice(i, i + 2)));
        }
        if (returnArray) {
            return sColorChange;
        } else {
            return 'RGB(" + sColorChange.join(",") + ")';
        }
    }
}

@Pipe({ name: 'mapColor' })
export class MapColorPipe implements PipeTransform {
    constructor() {}

    transform(color: string, alpha?: any) {
        if (!color) {
            return;
        }
        const _color = _ncolorMap[color] ? _ncolorMap[color] : color;
        if (!_color) {
            return;
        }
        if (!alpha) {
            return _color;
        } else {
            const _rgb = getRGB(_color, true);
            const _mixColor = mixColor(_rgb, [255, 255, 255], alpha);
            if (_mixColor) {
                return _mixColor;
            } else {
                return _color;
            }
        }
    }
}

@Pipe({ name: 'mapClass' })
export class MapClassPipe implements PipeTransform {
    constructor() {}

    transform(color, stiff) {
        const _color = COLOR_NAMES.find(item => item.color === color);
        if (_color) {
            return stiff ? stiff + _color.name : _color.name;
        } else {
            return '';
        }
    }
}

@Pipe({ name: 'colorHexToRgba' })
export class ColorHexToRgbaPipe implements PipeTransform {
    transform(value: any, alpha: any): any {
        return hexToRgba(value, alpha);
    }
}
